module.exports = {"110229001":"百泉街道","110229002":"香水园街道","110229003":"儒林街道","110229100":"延庆镇","110229101":"康庄镇","110229102":"八达岭镇","110229103":"永宁镇","110229104":"旧县镇","110229105":"张山营镇","110229106":"四海镇","110229107":"千家店镇","110229108":"沈家营镇","110229109":"大榆树镇","110229110":"井庄镇","110229207":"大庄科乡","110229209":"刘斌堡乡","110229210":"香营乡","110229214":"珍珠泉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110229.json
// module id = 39
// module chunks = 0